import styled from 'styled-components';

import Checkbox from '@mui/material/Checkbox';

export const OptionRow = styled.li`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  padding: ${({ theme }) => theme.spacing(1, 1.5)};
  font-size: 14px;
  line-height: 143%;
  letter-spacing: 0.17px;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const NavOptionRow = styled(OptionRow)`
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const LoadingRow = styled(NavOptionRow)`
  gap: ${({ theme }) => theme.spacing(1.25)};
  cursor: default;
`;

export const OptionCheckbox = styled(Checkbox)`
  width: ${({ theme }) => theme.spacing(3)};
  height: ${({ theme }) => theme.spacing(3)};
`;

export const OptionIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${({ theme }) => theme.spacing(4)};
  height: ${({ theme }) => theme.spacing(4)};
  border-radius: 8px;
  background: ${({ theme }) => theme.tint.primary.medium};
  color: ${({ theme }) => theme.palette.info.dark};

  svg {
    font-size: 18px;
  }
`;

export const OptionText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(0.25)};
  min-width: 0;
`;

export const OptionName = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const OptionMeta = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const OptionChevron = styled.span`
  display: inline-flex;
  margin-left: auto;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const NoteWrapper = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
  padding: ${({ theme }) => theme.spacing(1.25, 1.5)};
  border-radius: 8px;
  background: ${({ theme }) => theme.tint.primary.subtle};
  border: 1px solid ${({ theme }) => theme.tint.primary.medium};

  svg {
    font-size: 18px;
    color: ${({ theme }) => theme.palette.info.dark};
    flex-shrink: 0;
    margin-top: 1px;
  }
`;

export const NoteText = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const GroupChipIcon = styled.span`
  display: inline-flex;

  svg {
    font-size: 16px;
  }
`;

export const LicenceNotice = styled.div`
  margin-top: ${({ theme }) => theme.spacing(1.5)};
  padding: ${({ theme }) => theme.spacing(1.5, 2)};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.warning.light};
  font-size: 14px;
  color: ${({ theme }) => theme.toast.warning.text};
  background: ${({ theme }) => theme.toast.warning.background};
`;
